// Starter choice (shared/starter.ts STARTER_CHOICES): a new trainer's first
// screen. Three young beasts, one per mythology; clicking one selects it, the
// button confirms. The hunt keeps running underneath with the first choice, so
// nothing waits on this screen.
import { STARTER_CHOICES } from '../shared/starter.ts';
import { SPECIES, LINES } from '../shared/species.ts';
import { REGIONS } from '../shared/grounds.ts';
import { S } from './state.ts';
import { esc, elChip } from './fmt.ts';
import { spriteUrl } from './assets.ts';
import type { ClientMsg } from '../shared/protocol.ts';

let host: HTMLElement | null = null;
let picked: string = STARTER_CHOICES[0];
let sent = false;

function card(id: string): string {
  const sp = SPECIES[id];
  const line = LINES.find((l) => l.id === sp.line)!;
  const region = REGIONS.find((r) => r.id === sp.region)!;
  const on = id === picked;
  return `<button class="sp-card${on ? ' on' : ''}" data-sp="${id}" aria-pressed="${on}">
    <span class="sp-art"><img src="${spriteUrl(id)}" alt=""></span>
    <b class="sp-name">${esc(sp.name)}</b>
    <span class="sp-els">${sp.elements.map(elChip).join('')}</span>
    <span class="sp-from">${esc(region.name)}</span>
    <span class="sp-line" title="${esc(line.stages.map((s) => s.name).join(' → '))}">${line.stages.slice(1).map((s) => `<img src="${spriteUrl(s.id)}" alt="${esc(s.name)}">`).join('')}</span>
  </button>`;
}

function draw() {
  if (!host) return;
  host.innerHTML = `<div class="dialog sp-pick" role="dialog" aria-modal="true" aria-labelledby="sp-title">
    <h3 id="sp-title">Choose your starter</h3>
    <div class="sp-cards">${STARTER_CHOICES.map(card).join('')}</div>
    <div class="actions"><button class="btn gold" data-sp-go>Begin with ${esc(SPECIES[picked].name)}</button></div>
  </div>`;
}

export function renderStarterPick(send: (m: ClientMsg) => void) {
  const want = !!S.trainer?.starterPick && !S.trainer.namePick && !S.trainer.lookPick && !sent;
  if (!want) { if (host) { host.remove(); host = null; } if (!S.trainer?.starterPick) sent = false; return; }
  if (host) return;
  host = document.createElement('div');
  host.className = 'scrim sp-scrim';
  host.addEventListener('click', (e) => {
    const t = e.target as HTMLElement;
    const c = t.closest<HTMLElement>('[data-sp]');
    if (c) { picked = c.dataset.sp!; draw(); return; }
    if (t.closest('[data-sp-go]')) {
      sent = true;
      send({ t: 'starterPick', species: picked });
      host?.remove(); host = null;
    }
  });
  document.body.appendChild(host);
  draw();
}
